import script from "./PendingModule.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingModule.vue?vue&type=script&setup=true&lang=js"

import "./PendingModule.vue?vue&type=style&index=0&id=061890e1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-061890e1"]])

export default __exports__